export default "__VITE_ASSET__DBh8BkZN__"